export type AncillaryDateRange = {
  start: string | null
  end: string | null
}

export type AncillaryLineCell = {
  sureco: AncillaryDateRange | null
  noyo: AncillaryDateRange | null
  /** True when this line is why the person is on this tab. */
  problem: boolean
}

export type AncillaryRelationship = 'employee' | 'spouse' | 'child'

export const ANCILLARY_EXTRA_LINES = [
  'life',
  'add',
  'accident',
  'std',
  'ltd',
  'critical_illness',
  'cancer',
  'hospital_indemnity',
] as const

export type AncillaryExtraLine = (typeof ANCILLARY_EXTRA_LINES)[number]

export const ANCILLARY_EXTRA_LINE_LABEL: Record<AncillaryExtraLine, string> = {
  life: 'Life',
  add: 'AD&D',
  accident: 'Accident',
  std: 'STD',
  ltd: 'LTD',
  critical_illness: 'Critical Illness',
  cancer: 'Cancer',
  hospital_indemnity: 'Hospital Indemnity',
}

export type AncillaryReportRow = {
  employeePublicKey: string
  noyoEmployeeId: string | null
  personPublicKey: string | null
  firstName: string
  lastName: string
  relationship: AncillaryRelationship
  /** Employment status of this person's employee. Null when none is stored. */
  employmentStatus: string | null
  dental: AncillaryLineCell | null
  vision: AncillaryLineCell | null
  otherLines: Partial<Record<AncillaryExtraLine, AncillaryLineCell>>
  noyoStatus: string
  nextAction: string
  /** Sureco benefit ids for this person's discrepancy. Empty when looking good. */
  benefitIds: string[]
  assignee: string | null
}

export type AncillaryReportTabKey =
  | 'lookingGood'
  | 'recentlySubmitted'
  | 'termedStillCovered'
  | 'notMatch'
  | 'assigned'

export type AncillaryReport = Record<
  AncillaryReportTabKey,
  AncillaryReportRow[]
> & {
  clientName: string
  snapshotDate: string
}
